<template>
  <div class="modal fade" id="verify-employee-id-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="mb-0">Employee Verification</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Please provide your phone number to verify your identity and redeem your Employee Challenge incentive rewards.</p>
          <form ref="verifyEmployeeIdForm" method="post" action="/incentive-registration/verify" @submit.prevent="submit">
            <input type="hidden" name="_token" :value="csrf">
            <div class="form-group">
              <label class="required">Employee ID (Phone)*</label>
              <input type="number" name="phone" id="phone" class="form-control" value="" v-model="form.phone" required>
              <span v-if="errors.phone.length" class="help-block error-help-block">{{ errors.phone }}</span>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-secondary">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dealerUsesCashin: {
      type: Boolean,
      default: false
    },
    csrf: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      errors: {
        phone: ''
      },
      form: {
        phone: ''
      }
    }
  },
  methods: {
    submit() {
      this.errors.phone = '';

      if (this.form.phone.length != 10) {
        this.errors.phone = 'Phone number must be 10 digits.';
      } else {
        this.$refs.verifyEmployeeIdForm.submit()
      }
    },
  }
}
</script>